<template>
  <div v-if="file">
    <img
      v-if="fileTypeIsImage"
      :src="thumbnail"
      class="file-viewer-image"
      @click="onClickImage">
    <a
      v-else
      target="_blank"
      class="file-viewer-other p-2"
      :href="file">
      <img
        src="@/assets/images/file-icon.svg"
        class="mr-2">
      <strong>{{ filename }}</strong>
    </a>
    <image-modal
      v-if="showImageModal"
      :src="file"
      :blank-src="thumbnail"
      @hide="onHideModal" />
  </div>
</template>

<script>
import ImageModal from '@/components/parts/ImageModal'
export default {
  components: {
    ImageModal
  },
  props: {
    file: {
      type: String,
      required: true
    },
    thumbnail: {
      type: String,
      default: null
    },
    filename: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showImageModal: false
    }
  },
  computed: {
    fileExtension() {
      if (!this.file) return ''
      return this.file.split('?')[0].split('.').pop().trim()
    },
    fileTypeIsImage() {
      return !!this.thumbnail
    },
    decodedFileURL() {
      if (!this.file) return ''
      return decodeURI(this.file)
    },
    _filename() {
      if (this.filename) return this.filename
      if (!this.decodedFileURL) return ''
      return this.decodedFileURL.split('?')[0].split('/').pop()
    }
  },
  methods: {
    onClickImage() {
      this.showImageModal = true
    },
    onHideModal() {
      this.showImageModal = false
    },
  }
}
</script>

<style scoped lang="scss">
.file-viewer-image {
  object-fit: cover;
  max-width: 200px;
  border: 1px solid #EAEAEA;
  box-sizing: border-box;
}
.file-viewer-other {
  background: $white;
  border: 1px solid #D6DFE3;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}
</style>